import { ApiHttpService } from '../../services'

import router from '../../router'
export const PurchaseOrderV2Module = {
    namespaced: true,
    state: {
        data: {
            columns: [
                {
                    label: 'Doc Date',
                    field: 'date',
                    sort: 'asc',
                    width: '130'
                },
                {
                    label: 'DocNum',
                    field: 'series',
                    sort: 'asc',
                    clickable: true,
                    width: '150'
                },
              
                ],
            rows: [],
        },
        request : null,
        findRequest : null,
        multipleSelection: [],
        newItemDataObject: [],
        length: 25,
        page: 1,
        total: 1,
        searchTerm: null,
        filters: {},
        loading : false,
        postLoading : false,
        form : {},

        initialFormData : {
            series : "",
            date : "",
            status : "open",
            description: null,
            reference: 'local-purchase',
            discount: 0,
            attr : {
                eta_date : null,
                production_date : null,
                purchase_status : "P",
                approval_status : "draft"
            },
            vendor : {
                id : null,
                series : null,
                mobile : null,
                display : null,
                name : null 
            },
            items: [],
            
        },

        getLoading : false,
        getRecordLoading : false,
        putLoading : false,

        formStatus : 'create',
        
    },
    mutations: {
        addRequest : (state, req) => {
            state.request = {cancel : req.cancel, msg : "loading"}
            
        },
        cancelRequest : (state) => {
            state.request.cancel()
            state.loading = true
        },
        clearOldRequest(state, message) {
            state.request.msg = message;
            state.request = null;
        },
        addFindRequest : (state, req) => {
            state.findRequest = {cancel : req.cancel, msg : "loading"}
            
        },
        cancelFindRequest : (state) => {
            state.findRequest.cancel()
            state.loading = true
        },
        clearOldFindRequest(state, message) {
            state.findRequest.msg = message;
            state.findRequest = null;
        },
        setData(state, payload) {
            state.data = payload
        },
        loadingTrue(state) {
            state.loading = true
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setPostLoadingTrue: (state) => {
            state.postLoading = true
        },
        setPostLoadingFalse: (state) => {
            state.postLoading = false
        },
        setColumns(state, payload) {
            state.data.columns = payload
        },
        setRows(state, payload) {
            state.data.rows = payload
        },
        setPage: (state, payload) => {
            state.page = payload
        },
        setTotal: (state, payload) => {
            state.total = payload
        },
        setLength: (state, payload) => {
            state.length = payload
        },
        setSearchTerm: (state, payload) => {
            state.searchTerm = payload
        },
        setSelection: (state, payload) => {
            state.multipleSelection = payload
        },
        setFilters: (state, payload) => {
            state.filters = payload
        },
        setEmptyData: (state) => {
            state.data.rows = []
        },

        setFormData : (state, payload)=>{

            state.form = payload
        },

        setFormDataItems : (state, payload)=>{
            state.form.items = payload
        },
        setFormRowObject : (state, payload)=>{
            state.form.rowObject = payload
        },
        setNewItemDataObject : (state, payload)=>{
            state.newItemDataObject = payload
        },
        setEmptyForm : (state) => {
            state.form = JSON.parse(JSON.stringify(state.initialFormData))
        },

        setGetloadingTrue(state) {
            state.getLoading = true
        },
        setGetloadingFalse(state) {
            state.getLoading = false
        },
        setTerm: (state, payload) => {
            state.searchTerm = payload
        },

        setPutLoadingTrue : (state) => state.putLoading = true,
        setPutLoadingFalse : (state) => state.putLoading = false,

        setFormStatusCreate : (state) => state.formStatus = 'create',
        setFormStatusUpdate : (state) => state.formStatus = 'update',
        setGetRecordGetLoading : (state,payload) => state.getRecordLoading = payload,
    },
    actions : {
        resetData({dispatch}, endpoint){

        
            return new Promise((resolve, reject) => { 
                dispatch('asyncGetData', endpoint).then((res) => {

                    console.log("reset data")
                    console.log(res)
                    resolve(res)
                }).catch(error => {

                    console.log("reset error")
                    console.log(error)
                    reject(error)
                })
        });
        },
        async asyncGetData({ state, commit},endpoint) {
           
            const { length, page, filters, searchTerm } = state
            // alert(loading)
            return await new Promise((resolve, reject) => {
            
                    commit('setLoading', true)
                    commit('setRows', [])
                    commit('setFormStatusUpdate')
                    const params = { length: length, page: page, term: searchTerm, filters: filters, view : router.app._route.name }

                    const configParams = {
                        req : "PurchaseOrderV2Module/req",
                        loadingTrue : "PurchaseOrderV2Module/loadingTrue",
                        addRequest : "PurchaseOrderV2Module/addRequest",
                        cancelRequest : "PurchaseOrderV2Module/cancelRequest",
                        clearOldRequest : "PurchaseOrderV2Module/clearOldRequest"
                    }

                    ApiHttpService.get(endpoint, params, configParams).then((response) => {
                        commit('setRows', response.data.data)
                        commit('setPage',response.data.current_page)
                        commit('setTotal',response.data.total)
                        commit('setLoading', false)
                        resolve(response.data.data)
                    }).catch(error => {
                        commit('setLoading', false)
                        reject(error)
                    })
                
            })
        },
        async findPurchaseOrder({ state, commit},params) {
           
            const { length, page, filters, searchTerm } = state
            // alert(loading)
            return await new Promise((resolve, reject) => {
                    commit('setLoading', true)

                    const configParams = {
                        req : "PurchaseOrderV2Module/findRequest",
                        loadingTrue : "PurchaseOrderV2Module/loadingTrue",
                        addRequest : "PurchaseOrderV2Module/addFindRequest",
                        cancelRequest : "PurchaseOrderV2Module/cancelFindRequest",
                        clearOldRequest : "PurchaseOrderV2Module/clearOldFindRequest"
                    }
                    const initialFormData = {...JSON.parse(JSON.stringify(state.initialFormData)), items : []}
                    ApiHttpService.get('purchase-order/find', params, configParams).then((response) => {
                        const data = response.data


                        const documentLines = response.data.items.map((item) => {
                            const itmDimension = (item.item  === null) ? "" : item.item.dimension
                            const itmDefault = (item.item  === null) ? "" : item.item.default
                            const isValid = (item.item  === null) ? false : true
                            return {
                                parent_code : item.parent_code,
                                code : item.code,
                                photo : itmDefault,
                                name : item.name,
                                dimension : itmDimension,
                                unit_price : item.unit_price,
                                quantity : item.qty,
                                price : item.price,
                                discount : item.discount_percent,
                                total : item.line_total,
                                description : item.remarks,
                                id : item.id,
                                attr : item.attr,
                                valid : isValid,
                                line_num : item.line_num
                            }
                        })


                        const responseData = {...initialFormData,...response.data,items : documentLines, vendor : {
                            ...response.data.vendor,
                            display : `${data.vendor.name}/${data.vendor.mobile}`,
                            value : data.vendor.id,
                            label : data.vendor.series,
                            opt : `${data.vendor.series} - ${data.vendor.name}/${data.vendor.mobile}`
                        }}

                        console.log("responseData")
                        console.log(responseData)
                        commit('setFormData',responseData)

                        resolve(responseData)
                    }).catch(error => {
                        commit('setLoading', false)
                        reject(error)
                    })
                
            })
        },


        async getRecord({ state, commit},obj) {

            const { getLoading} = state
            return await new Promise((resolve, reject) => {
                if (getLoading === false) {
                    commit('setGetloadingTrue', true)

                    const initialFormData = {...JSON.parse(JSON.stringify(state.initialFormData)),...obj, items : []}
 
                    ApiHttpService.getRequest('purchase-order/'+obj.series,{view : router.app._route.name}).then((response) => {
                        commit('setGetloadingFalse', false) 


                       /*  const itemFilter = response.data.items.filter((item) => item.item === null,[])

                        console.log("itemFilter")
                        console.log(itemFilter)
                         */

                        const documentLines = response.data.items.map((item) => {
                            const itmDimension = (item.item  === null) ? "" : item.item.dimension
                            const itmDefault = (item.item  === null) ? "" : item.item.default
                            const isValid = (item.item  === null) ? false : true
                            return {
                               /*  ...item,
                                series : item.code,
                                quantity : item.qty,
                                discount : item.discount_percent,
                                total : item.line_total,
                                description : item.remarks,
                                dimension : itmDimension,
                                photo : itmDefault,
                                valid : true */
                                parent_code : item.parent_code,
                                code : item.code,
                                photo : itmDefault,
                                name : item.name,
                                dimension : itmDimension,
                                unit_price : item.unit_price,
                                quantity : item.qty,
                                price : item.price,
                                discount : item.discount_percent,
                                total : item.line_total,
                                description : item.description,
                                id : item.id,
                                attr : item.attr,
                                valid : isValid,
                                line_num : item.line_num
                            }
                        })

                        const data = response.data

                        const responseData = {...initialFormData,...response.data, items : documentLines, vendor : {
                            ...response.data.vendor,
                            display : `${data.vendor.name}/${data.vendor.mobile}`,
                            value : data.vendor.id,
                            label : data.vendor.series,
                            opt : `${data.vendor.series} - ${data.vendor.name}/${data.vendor.mobile}`
                        }}
                        commit('setFormData',responseData)
                        resolve(responseData)
                    }).catch(error => {
                        commit('setGetloadingFalse', false)
                        reject(error)
                    })
                }
            })
        },
        
       
        
      
        async storeRecord({ state, commit }, payload) {
            return await new Promise((resolve, reject) => {
                const postLoading = state.postLoading;
                if (!postLoading) {
                    commit('setPostLoadingTrue')
                    const parsePayload = JSON.parse(JSON.stringify(payload))
                    const configParams = {
                        req : "PurchaseOrderV2Module/req",
                        loadingTrue : "PurchaseOrderV2Module/setPostLoadingTrue",
                        addRequest : "PurchaseOrderV2Module/addRequest",
                        cancelRequest : "PurchaseOrderV2Module/cancelRequest",
                        clearOldRequest : "PurchaseOrderV2Module/clearOldRequest"
                    }
                    ApiHttpService.post('purchase-order',parsePayload,configParams).then((response) => {
                        commit('setPostLoadingFalse')
                        commit('setNewItemDataObject',response.data)
                        resolve(response.data)
                    }).catch((error) => {
                        commit('setPostLoadingFalse')
                        reject(error)
                    })
                }
            })
        },

        updateRecord({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                const putLoading = state.putLoading;
                if (!putLoading) {
                    commit('setPutLoadingTrue')
                    const updatePayload = JSON.parse(JSON.stringify(payload))
                    ApiHttpService.update(`purchase-order/${updatePayload.series}`,updatePayload).then((response) => {
                        commit('setPutLoadingFalse')
                        let responseData = {...response.data.data};
                        resolve(responseData)
                    }).catch((error) => {
                        commit('setPutLoadingFalse')
                        reject(error)
                    })
                }
            })
        },
    },
    getters: {
        rows: state => state.data.rows,
        data: state => state.data,
        columns: state => state.data.columns,
        selection : state => state.multipleSelection,
        loading : state => state.loading,
        page: state => state.page,
        total: state => state.total,
        length: state => state.length,
        searchTerm: state => state.searchTerm,
        filters: state => state.filters,
        req: state => state.request,
        findRequest: state => state.findRequest,
        form: state => state.form,
        initialFormObject: state => state.initialFormData,
        getLoading: state => state.getLoading,
        formData: state => state.form,
        formStatus: state => state.formStatus,
        putLoading: state => state.putLoading,
        postLoading: state => state.postLoading,
        getNewItemDataObject: state => state.newItemDataObject,
    }
}



